import Vue from 'vue'

const STORAGE_KEY = 'trajectoryColorSettings'
const LEGACY_COLOR_KEY = 'transportServiceTrajectoryColor'
const bus = new Vue()

export const TRAJECTORY_COLOR_MODE_SOLID = 'solid'
export const TRAJECTORY_COLOR_MODE_SPEED = 'speed'
export const TRAJECTORY_SPEED_MODE_VALUE = '__speed__'

export const DEFAULT_SOLID_TRAJECTORY_COLOR = '#2FAE55,#98E0AD,#1E7B3B'

export const TRAJECTORY_SOLID_COLOR_OPTIONS = [
  { label: '黄色', value: '#D8A800,#FFE38A,#9E7600', swatch: '#d8a800' },
  { label: '蓝色', value: '#2B6DFF,#9FC2FF,#1E4FB8', swatch: '#2b6dff' },
  { label: '绿色', value: '#2FAE55,#98E0AD,#1E7B3B', swatch: '#2fae55' },
  { label: '红色', value: '#E24A4A,#FFB3B3,#A63131', swatch: '#e24a4a' }
]

function readLegacySolidColor() {
  if (typeof window === 'undefined' || !window.localStorage) return ''
  try {
    const saved = window.localStorage.getItem(LEGACY_COLOR_KEY)
    return saved && String(saved).trim() ? String(saved).trim() : ''
  } catch (e) {
    return ''
  }
}

export function normalizeTrajectoryColorSettings(raw) {
  const base = raw && typeof raw === 'object' ? raw : {}
  let mode = base.mode === TRAJECTORY_COLOR_MODE_SPEED ? TRAJECTORY_COLOR_MODE_SPEED : TRAJECTORY_COLOR_MODE_SOLID
  let solidColor = base.solidColor != null ? String(base.solidColor).trim() : ''
  if (!solidColor) solidColor = readLegacySolidColor() || DEFAULT_SOLID_TRAJECTORY_COLOR
  const valid = TRAJECTORY_SOLID_COLOR_OPTIONS.some((o) => o.value === solidColor)
  if (!valid) solidColor = DEFAULT_SOLID_TRAJECTORY_COLOR
  return { mode, solidColor }
}

export function getTrajectoryColorSettings() {
  if (typeof window === 'undefined' || !window.localStorage) {
    return normalizeTrajectoryColorSettings(null)
  }
  try {
    const saved = window.localStorage.getItem(STORAGE_KEY)
    if (!saved) return normalizeTrajectoryColorSettings(null)
    return normalizeTrajectoryColorSettings(JSON.parse(saved))
  } catch (e) {
    return normalizeTrajectoryColorSettings(null)
  }
}

export function saveTrajectoryColorSettings(next) {
  const normalized = normalizeTrajectoryColorSettings(next)
  if (typeof window !== 'undefined' && window.localStorage) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(normalized))
      window.localStorage.setItem(LEGACY_COLOR_KEY, normalized.solidColor)
    } catch (e) {
      /* ignore */
    }
  }
  bus.$emit('change', normalized)
  return normalized
}

export function onTrajectoryColorSettingsChange(handler) {
  bus.$on('change', handler)
  return () => bus.$off('change', handler)
}

export function isSpeedTrajectoryColorMode(settings) {
  const cfg = settings || getTrajectoryColorSettings()
  return cfg.mode === TRAJECTORY_COLOR_MODE_SPEED
}
